<div class="dias-selector" role="group" aria-label="Días">
  @for (dia of dias; track dia.valor) {
    <button
      type="button"
      class="irx-celda irx-celda--marco dia"
      [disabled]="disabled"
      [attr.aria-pressed]="activo(dia.valor)"
      [attr.aria-label]="dia.nombre"
      [title]="dia.nombre"
      (click)="toggle(dia.valor)"
    >
      {{ dia.label }}
    </button>
  }
</div>
